import { render, staticRenderFns } from "./loHeading.vue?vue&type=template&id=69067bb8&scoped=true&"
import script from "./loHeading.vue?vue&type=script&lang=js&"
export * from "./loHeading.vue?vue&type=script&lang=js&"
import style0 from "./loHeading.vue?vue&type=style&index=0&id=69067bb8&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "69067bb8",
  null
  
)

export default component.exports